/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Sidebar_Note_2Inputs */

const en_home_bench_sidebar_note_2 = /** @type {(inputs: Home_Bench_Sidebar_Note_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are starting points.`)
};

const lv_home_bench_sidebar_note_2 = /** @type {(inputs: Home_Bench_Sidebar_Note_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šie ir tikai sākumpunkti.`)
};

/**
* | output |
* | --- |
* | "These are starting points." |
*
* @param {Home_Bench_Sidebar_Note_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_sidebar_note_2 = /** @type {((inputs?: Home_Bench_Sidebar_Note_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Sidebar_Note_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_sidebar_note_2(inputs)
	return en_home_bench_sidebar_note_2(inputs)
});